import React, { useMemo } from 'react';
import cls from 'clsx';
import { Down } from '@linktivity/link-icons';
import { useRandomId } from '@link/share/hooks';
import { IPanelProps } from './Collapse.types';
import { useCollapseContext } from './context';
import styles from './collapse.module.css';

const Panel: React.FC<IPanelProps> = ({
  id,
  header,
  extra,
  disabled = false,
  className = '',
  children,
  ...divProps
}) => {
  const { currentPanel, updatePanel } = useCollapseContext();

  const panelId = useRandomId(id);
  const expanded = useMemo(
    () => currentPanel.includes(panelId),
    [currentPanel, panelId]
  );
  const handleExpanded = () => {
    if (disabled) return;
    updatePanel(panelId);
  };
  return (
    <div className={cls(styles.panel, className)} {...divProps}>
      <div className={styles.panelHeader}>
        <div
          className={cls(styles.panelHeaderContent, {
            [styles.panelHeaderContentText]: typeof header === 'string',
            [styles.panelHeaderContentDisabled]: disabled
          })}
          role="button"
          onClick={handleExpanded}
        >
          {header}
        </div>
        {extra}
        <button
          type="button"
          className={styles.panelHeaderExpandIcon}
          disabled={disabled}
          onClick={handleExpanded}
        >
          <Down
            className={cls(styles.panelIcon, {
              [styles.expanded]: expanded
            })}
          />
        </button>
      </div>
      <div
        role="region"
        className={cls(styles.panelBody, {
          [styles.expanded]: expanded
        })}
      >
        <div className={styles.panelInner}>{children}</div>
      </div>
    </div>
  );
};

export default Panel;
